import { createContext, useContext, ReactNode, useState, FC } from "react";
import { IInputCreateLeads } from "../Leads/LeadsTypes";
import {
  IContextLandingPages,
  IListLandingPages,
  ISellerData,
} from "./LandingPagesTypes";
import { useAuthContext } from "../AuthContext/authContext";

const LandingPagesContext = createContext({} as IContextLandingPages);

export const LandingPagesContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { userPerfil } = useAuthContext();
  const [listLandingPages, setListLandingPages] = useState(
    [] as IListLandingPages[]
  );

  const [valuesInputsLeads, setValuesInputsLeads] = useState<IInputCreateLeads>(
    {} as IInputCreateLeads
  );

  const [sellerData, setSellerData] = useState<ISellerData>({
    idTenant: userPerfil?.idTenant || "",
    name: userPerfil?.name || "",
    email: userPerfil?.email || "",
    phone1: userPerfil?.phone1 || "",
    phone2: userPerfil?.phone2 || "",
  } as ISellerData);

  const [idLandingPage, setIdLandingPage] = useState("");
  const [idTenant, setIdTenant] = useState("");

  return (
    <LandingPagesContext.Provider
      value={{
        setListLandingPages,
        listLandingPages,
        setValuesInputsLeads,
        valuesInputsLeads,
        setIdLandingPage,
        idLandingPage,
        setIdTenant,
        idTenant,
        sellerData,
        setSellerData,
      }}
    >
      {children}
    </LandingPagesContext.Provider>
  );
};

export const useContextLandingPages = (): IContextLandingPages =>
  useContext(LandingPagesContext);
